export default __webpack_public_path__ + "static/media/select-crop-area.f055fe6b.svg";